module.exports = __webpack_public_path__ + "static/media/48.1dfd4b99.png";